var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.06654H1.03421C0.473682 8.06654 0 7.58735 0 7.02828V4.71212C0 2.15638 1.83948 0 4.07369 0H17.8895C20.1237 0 21.9632 2.07651 21.9632 4.71212V7.02828C21.9632 7.58735 21.4816 8.06654 21.0079 8.06654H21ZM1.99737 6.06987H19.9658V4.79202C19.9658 3.27454 19.0105 2.07652 17.8895 2.07652H4.07369C2.95264 2.07652 1.99737 3.27454 1.99737 4.79202V6.06987Z",
    fill: "url(#paint0_linear_486_2219)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8895 38.0166H4.07369C1.83948 38.0166 0 35.9401 0 33.3044V30.9883C0 30.4293 0.481577 29.9501 1.03421 29.9501H21C21.5605 29.9501 22.0421 30.4293 22.0421 30.9883V33.3044C21.9632 35.9401 20.1237 38.0166 17.8895 38.0166ZM1.99737 32.0266V33.3044C1.99737 34.8219 2.95264 36.0199 4.07369 36.0199H17.8895C19.0105 36.0199 19.9658 34.8219 19.9658 33.3044V32.0266H1.99737Z",
    fill: "url(#paint1_linear_486_2219)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 32.0266H1.03421C0.473682 32.0266 0 31.5474 0 30.9883V7.02825C0 6.46918 0.481577 5.98999 1.03421 5.98999H21C21.5605 5.98999 22.0421 6.46918 22.0421 7.02825V30.9883C21.9632 31.5474 21.4816 32.0266 21 32.0266ZM1.99737 30.0299H19.9658V8.06651H1.99737V30.0299Z",
    fill: "url(#paint2_linear_486_2219)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9576 18.0499H25.9575C25.397 18.0499 24.9233 17.5707 24.9233 17.0116V14.6955C24.9233 12.1397 26.8417 9.98334 29.1549 9.98334H43.6891C46.0023 9.98334 47.9207 12.0598 47.9207 14.6955V17.0116C47.9207 17.5707 47.4391 18.0499 46.9654 18.0499H46.9576ZM26.9918 16.0532H45.9154V14.7754C45.9154 13.2579 44.8812 12.0599 43.6812 12.0599H29.147C27.947 12.0599 26.9128 13.2579 26.9128 14.7754V16.0532H26.9918Z",
    fill: "url(#paint3_linear_486_2219)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6818 48H29.1476C26.8344 48 24.916 45.9235 24.916 43.2878V40.9717C24.916 40.4127 25.3976 39.9335 25.9502 39.9335H46.9502C47.5108 39.9335 47.9923 40.4127 47.9923 40.9717V43.2878C47.9134 45.9235 45.995 48 43.6818 48ZM26.9923 42.01V43.2878C26.9923 44.8053 28.0344 46.0033 29.2265 46.0033H43.7608C44.9608 46.0033 45.995 44.8053 45.995 43.2878V42.01H26.9844H26.9923Z",
    fill: "url(#paint4_linear_486_2219)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9576 42.01H25.9575C25.397 42.01 24.9233 41.5308 24.9233 40.9717V17.0116C24.9233 16.4526 25.4049 15.9734 25.9575 15.9734H46.9576C47.5181 15.9734 47.9996 16.4526 47.9996 17.0116V40.9717C47.9207 41.5308 47.4391 42.01 46.9576 42.01ZM26.9918 40.0133H45.9154V18.0499H26.9918V40.0133Z",
    fill: "url(#paint5_linear_486_2219)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99219 23.0815L9.82902 13.0981H11.6685L15.5053 23.0815H13.0264L12.229 20.8452H9.19745L8.40007 23.0815H6.00797H5.99219ZM10.6974 15.4942L9.49745 19.2479H11.8106L10.6896 15.4942H10.6974Z",
    fill: "url(#paint6_linear_486_2219)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9053 35.0616V24.9984H36.6553C37.4526 24.9984 38.1711 25.1581 38.8105 25.3977C39.45 25.6373 39.9316 26.0366 40.3263 26.4359C40.729 26.9151 41.0448 27.3944 41.2816 28.0333C41.5184 28.6722 41.6053 29.3112 41.6053 29.9501C41.6053 30.7488 41.5263 31.3877 41.2816 32.0266C41.0448 32.6656 40.7211 33.1448 40.2474 33.624C39.8448 34.0233 39.2921 34.4226 38.6526 34.6622C38.0132 34.9018 37.3737 34.9817 36.5763 34.9817H32.9053V35.0616ZM39.2921 30.03C39.2921 29.5508 39.2132 29.1514 39.1342 28.832C39.0553 28.4326 38.8184 28.193 38.6526 27.8735C38.4158 27.6339 38.1711 27.3944 37.8553 27.2346C37.5395 27.0749 37.1369 26.995 36.7342 26.995H35.2974V32.9051H36.7342C37.1369 32.9051 37.5316 32.8253 37.8553 32.6656C38.1789 32.5058 38.4947 32.3461 38.6526 32.0266C38.8895 31.787 39.0553 31.4676 39.1342 31.0682C39.2132 30.8286 39.2921 30.4293 39.2921 30.03Z",
    fill: "url(#paint7_linear_486_2219)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02621 41.0516H3.99463V44.0865H7.02621V41.0516Z",
    fill: "url(#paint8_linear_486_2219)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0526 41.0516H11.021V44.0865H14.0526V41.0516Z",
    fill: "url(#paint9_linear_486_2219)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 41.0516H17.9683V44.0865H20.9998V41.0516Z",
    fill: "url(#paint10_linear_486_2219)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0238 4.07318H26.9922V7.10811H30.0238V4.07318Z",
    fill: "url(#paint11_linear_486_2219)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.971 4.07318H33.9395V7.10811H36.971V4.07318Z",
    fill: "url(#paint12_linear_486_2219)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9974 4.07318H40.9658V7.10811H43.9974V4.07318Z",
    fill: "url(#paint13_linear_486_2219)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_2219",
    x1: 10.9816,
    y1: 0,
    x2: 10.9816,
    y2: 8.06654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_2219",
    x1: 11.021,
    y1: 29.9501,
    x2: 11.021,
    y2: 38.0166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_2219",
    x1: 11.021,
    y1: 5.98999,
    x2: 11.021,
    y2: 32.0266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_2219",
    x1: 36.422,
    y1: 9.98334,
    x2: 36.422,
    y2: 18.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_2219",
    x1: 36.4542,
    y1: 39.9335,
    x2: 36.4542,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_2219",
    x1: 36.4615,
    y1: 15.9734,
    x2: 36.4615,
    y2: 42.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_2219",
    x1: 10.7488,
    y1: 13.0981,
    x2: 10.7488,
    y2: 23.0815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_2219",
    x1: 37.2553,
    y1: 24.9984,
    x2: 37.2553,
    y2: 35.0616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_2219",
    x1: 5.51042,
    y1: 41.0516,
    x2: 5.51042,
    y2: 44.0865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_2219",
    x1: 12.5368,
    y1: 41.0516,
    x2: 12.5368,
    y2: 44.0865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_486_2219",
    x1: 19.4841,
    y1: 41.0516,
    x2: 19.4841,
    y2: 44.0865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_486_2219",
    x1: 28.508,
    y1: 4.07318,
    x2: 28.508,
    y2: 7.10811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_486_2219",
    x1: 35.4552,
    y1: 4.07318,
    x2: 35.4552,
    y2: 7.10811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_486_2219",
    x1: 42.4816,
    y1: 4.07318,
    x2: 42.4816,
    y2: 7.10811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon17);
export default __webpack_public_path__ + "static/media/icon17.17117c8a554bec561b7e1100f89b0267.svg";
export { ForwardRef as ReactComponent };